<footer class="clearfix">
  <div class="container-fluid">
    <div class="col-sm-11 d-flex center-block justify-content-between">
      <div>
        <strong>Reed Tech SingleSource&trade; for Medical Devices v13.0</strong>&nbsp;&nbsp;Copyright © {{currentYear}}
        Reed
        Technology and Information Services Inc.
      </div>
      <div>
        <ul class="footerLinks">
          <li *ngIf="lastLogonDate"> <span aria-label="Last sign-in date" *ngIf='lastLogonDate'> Last sign-in:
              {{lastLogonDate | utcToLocale}}</span></li>

          <li> <a href="http://go.reedtech.com/singlesource_terms" target="_blank" role="button"
              aria-label="Terms Conditions">Terms &amp; Conditions</a></li>

          <li><a href="http://www.lexisnexis.com/en-us/terms/privacy-policy.page" target="_blank" role="button"
              aria-label="Privacy Policy">Privacy Policy</a>
          </li>

          <li>
            <a href="javascript: void(0);" id="ot-sdk-btn" class="ot-sdk-show-settings" role="button"
              aria-label="Cookies Settings">Cookies Settings</a>
          </li>

          <li>
            <img src="../../../assets/images/relxgroupLogo2017sm.png" class="relx-logo" alt="RELX Group">
          </li>

        </ul>
      </div>

    </div>
  </div>
</footer>
